module.exports = __webpack_public_path__ + "static/media/next.3dea34eb.svg";